import React, { useEffect, useState } from "react";
import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Button,
  Text,
  Spinner,
  HStack,
  Input,
  Select,
  useToast,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Input as ChakraInput,
  IconButton,
  Image,
  Textarea,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  FormControl,
  FormLabel,
  Grid,
  GridItem,
  VStack,
} from "@chakra-ui/react";
import { supabase } from "../../../lib/supabaseClient";
import {
  CheckIcon,
  CloseIcon,
  EditIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
} from "@chakra-ui/icons";

const COLUMN_MAP = [
  { key: "contractor_name", label: "계약자명" },
  { key: "represent_channel", label: "대표채널" },
  { key: "channel_count", label: "등록 채널" },
  { key: "commission", label: "수수료" },
  { key: "email", label: "이메일" },
  { key: "phone", label: "전화번호" },
  { key: "partner", label: "파트너" },
  { key: "contract_file", label: "계약서 파일" },
  { key: "contract_date", label: "계약일" },
];

const PAGE_SIZE = 20;
const BUCKET = "shorts-contract"; // 실제 버킷명으로 수정 필요

const Contracts = () => {
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [sortBy, setSortBy] = useState("created_date");
  const [sortOrder, setSortOrder] = useState("desc");
  const toast = useToast();
  const [infoModal, setInfoModal] = useState({ open: false, data: null });
  const [ownedAlbums, setOwnedAlbums] = useState([]);
  const [ownedAlbumsTotal, setOwnedAlbumsTotal] = useState(0);
  const [editFields, setEditFields] = useState({
    commission: "",
    contract_file: "",
    memo: "",
  });
  const [saving, setSaving] = useState(false);
  const [channelPage, setChannelPage] = useState(1);
  const [albumPage, setAlbumPage] = useState(1);
  const MODAL_PAGE_SIZE = 10;
  const [deleteDialog, setDeleteDialog] = useState({ open: false, row: null });
  const cancelRef = React.useRef();
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [addForm, setAddForm] = useState({
    contractor: "",
    contractor_name: "",
    email: "",
    phone: "",
    partner: "",
    partner_name: "",
    commission: "",
    contract_date: "",
    contract_file: "",
    memo: "",
    test: "FALSE",
    test_period: "",
  });
  const [adding, setAdding] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [editUploading, setEditUploading] = useState(false);
  const [editTrackCommission, setEditTrackCommission] = useState({
    trackId: null,
    value: "",
  });
  const [savingTrackCommission, setSavingTrackCommission] = useState(false);
  const [searchModalOpen, setSearchModalOpen] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [inputPage, setInputPage] = useState(page.toString());

  useEffect(() => {
    fetchRows();
    setInputPage(String(page));
    // eslint-disable-next-line
  }, [page, sortBy, sortOrder]);

  const fetchRows = async (searchKeyword = search) => {
    setLoading(true);
    const { data, error } = await supabase.rpc("fetch_contracted_channels", {
      search_keyword: searchKeyword,
      page,
      sort_by: sortBy,
      sort_order: sortOrder,
    });
    if (!error && Array.isArray(data)) {
      setRows(data);
      setTotal(data[0]?.total_count || 0);
    }
    setLoading(false);
  };

  // 계약서 파일 다운로드 (signed url)
  const handleFileDownload = async (fileUrl) => {
    if (!fileUrl)
      return toast({ title: "파일 없음", status: "error", duration: 2000 });
    try {
      window.open(fileUrl, "_blank"); // url 그대로 새 창(탭)으로 열기
    } catch (e) {
      toast({ title: "다운로드 실패", status: "error", duration: 2000 });
    }
  };

  // 삭제
  const handleDelete = (row) => {
    setDeleteDialog({ open: true, row });
  };
  const confirmDelete = async () => {
    if (!deleteDialog.row) return;
    // 1. supabase에서 contractor(계약자 이메일)로 id 조회
    const { data: contractRow, error: idError } = await supabase
      .from("shorts_contract")
      .select("id")
      .eq("contractor", deleteDialog.row.contractor)
      .single();
    const contractId = contractRow?.id;
    // 2. 외부 API 삭제 (채널 승인 방식 참고)
    // 계약자 이메일로 user id 조회
    const { data: userData } = await supabase
      .from("user")
      .select("id")
      .eq("email", deleteDialog.row.contractor)
      .single();
    const userId = userData?.id;
    const tokenRes = await fetch("https://plpl.rhoonart.co.kr/auth/token", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ userId }),
    });
    const tokenJson = await tokenRes.json();
    const access_token = tokenJson.data?.access_token;
    // 외부 API 삭제
    if (contractId) {
      await fetch(`https://plpl.rhoonart.co.kr/contracts/${contractId}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
    }
    // 3. supabase에서 삭제
    const { error } = await supabase
      .from("shorts_contract")
      .delete()
      .eq("contractor", deleteDialog.row.contractor);
    setDeleteDialog({ open: false, row: null });
    if (!error) {
      toast({ title: "삭제 완료", status: "success", duration: 1500 });
      fetchRows();
    } else {
      toast({ title: "삭제 실패", status: "error", duration: 2000 });
    }
  };
  const cancelDelete = () => setDeleteDialog({ open: false, row: null });

  // 정보확인 모달
  const openInfoModal = async (row) => {
    setInfoModal({ open: true, data: row });
    setEditFields({
      commission: row.commission ?? "",
      contract_file: row.contract_file ?? "",
      memo: row.memo ?? "",
    });
    setChannelPage(1);
    setAlbumPage(1);
    // fetch_user_album_tracks RPC 사용
    const { data, error } = await supabase.rpc("fetch_user_album_tracks", {
      target_email: row.email,
      search_keyword: "",
      page_limit: 1000,
      page_offset: 0,
    });
    if (!error && Array.isArray(data)) {
      const processed = data.map((item) => ({
        id: item.track_code,
        albumId: item.album_id,
        trackCode: item.track_code,
        trackId: item.track_id,
        youtubeId: item.youtube_url
          ? item.youtube_url.match(/(?:v=|youtu.be\/|embed\/)([\w-]{11})/)?.[1]
          : "",
        youtubeUrl: item.youtube_url,
        trackName: item.track_name,
        albumName: item.album_name,
        albumCover: item.album_cover,
        artist: item.musician_name,
        isrc: item.isrc,
        genre: item.genre || "-",
        mood: Array.isArray(item.mood)
          ? item.mood.join(", ")
          : item.mood || "-",
        mp3: item.mp3,
        wav: item.wav,
        registered_at: item.registered_at,
        published_at: item.published_at,
        commission_rate: item.commission_rate,
      }));
      setOwnedAlbums(processed);
      setOwnedAlbumsTotal(data[0]?.total_count || processed.length);
    } else {
      setOwnedAlbums([]);
      setOwnedAlbumsTotal(0);
    }
  };
  const closeInfoModal = () => setInfoModal({ open: false, data: null });

  // 대표채널 추출
  const getRepresentChannel = (channels) => {
    if (!channels || !Array.isArray(channels) || channels.length === 0)
      return "-";
    return channels[0]?.channel_title || "-";
  };

  // 수정 필드 변경
  const handleEditFieldChange = (key, value) => {
    setEditFields((prev) => ({ ...prev, [key]: value }));
  };

  // 저장
  const handleSaveEdit = async () => {
    if (!infoModal.data) return;
    setSaving(true);

    // 1. supabase에서 id 조회
    const { data: contractRow } = await supabase
      .from("shorts_contract")
      .select("id")
      .eq("contractor", infoModal.data.contractor)
      .single();
    const contractId = contractRow?.id;

    // 2. 계약자 이메일로 user id 조회
    const { data: userData } = await supabase
      .from("user")
      .select("id")
      .eq("email", infoModal.data.contractor)
      .single();
    const userId = userData?.id;

    // 3. 토큰 발급
    const tokenRes = await fetch("https://plpl.rhoonart.co.kr/auth/token", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ userId }),
    });
    const tokenJson = await tokenRes.json();
    const access_token = tokenJson.data?.access_token;

    // 4. 외부 API로 전송할 body 생성 (모든 데이터 포함)
    const body = {
      id: contractId,
      contractFile: editFields.contract_file,
      contractorId: infoModal.data.contractor,
      name: infoModal.data.contractor_name,
      email: infoModal.data.email,
      phone: infoModal.data.phone,
      partnerId: infoModal.data.partner,
      partnerName: infoModal.data.partner_name,
      commissionRatio: Number(editFields.commission) || 0,
      contractAt: infoModal.data.contract_date
        ? toIsoDatetimeString(infoModal.data.contract_date)
        : null,
      memo: editFields.memo,
      test: infoModal.data.test === "TRUE" || infoModal.data.test === true,
      testPeriod: infoModal.data.test_period
        ? toIsoDatetimeString(infoModal.data.test_period)
        : null,
      creatorId: userId,
      createAt: infoModal.data.create_at
        ? toIsoDatetimeString(infoModal.data.create_at)
        : toIsoDatetimeString(new Date()),
      updateAt: toIsoDatetimeString(new Date()),
    };

    // 5. 외부 API에 PUT 요청
    await fetch(`https://plpl.rhoonart.co.kr/contracts/${contractId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access_token}`,
      },
      body: JSON.stringify(body),
    });

    // 6. supabase에서 삭제
    await supabase
      .from("shorts_contract")
      .delete()
      .eq("contractor", infoModal.data.contractor);

    setSaving(false);
    toast({ title: "수정 완료", status: "success", duration: 1500 });
    closeInfoModal();
    fetchRows();
  };

  // contract 단위로 중복 row 제거(혹시라도 중복이 있을 경우)
  const uniqRows = Array.isArray(rows)
    ? rows.filter(
        (row, idx, arr) =>
          arr.findIndex((r) => r.contractor === row.contractor) === idx
      )
    : [];

  // 계약 추가 핸들러
  const handleAddChange = (key, value) => {
    setAddForm((prev) => ({ ...prev, [key]: value }));
  };

  // ISO8601 날짜 변환 함수
  function toIsoDatetimeString(date) {
    if (!date) return null;
    const d = typeof date === "string" ? new Date(date) : date;
    return d.toISOString();
  }

  const handleAddSave = async () => {
    setAdding(true);
    // 1. supabase에 저장
    const { data: insertData, error } = await supabase
      .from("shorts_contract")
      .insert([addForm])
      .select("id")
      .single();
    setAdding(false);

    if (!error && insertData?.id) {
      // 2. access_token 발급 (채널 승인 방식 참고)
      // 계약자(본인) 이메일로 user id 조회
      const { data: userData } = await supabase
        .from("user")
        .select("id")
        .eq("email", addForm.contractor)
        .single();
      const userId = userData?.id;
      const tokenRes = await fetch("https://plpl.rhoonart.co.kr/auth/token", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId }),
      });
      const tokenJson = await tokenRes.json();
      const access_token = tokenJson.data?.access_token;

      // 3. 외부 API로 전송할 body 생성
      const body = {
        id: insertData.id,
        contractFile: addForm.contract_file,
        contractorId: addForm.contractor,
        name: addForm.contractor_name,
        email: addForm.email,
        phone: addForm.phone,
        partnerId: addForm.partner,
        partnerName: addForm.partner_name,
        commissionRatio: Number(addForm.commission) || 0,
        contractAt: addForm.contract_date
          ? toIsoDatetimeString(addForm.contract_date)
          : null,
        memo: addForm.memo,
        test: addForm.test === "TRUE" || addForm.test === true,
        testPeriod: addForm.test_period
          ? toIsoDatetimeString(addForm.test_period)
          : null,
        creatorId: userId,
        createAt: toIsoDatetimeString(new Date()),
        updateAt: toIsoDatetimeString(new Date()),
      };

      await fetch("https://plpl.rhoonart.co.kr/contracts", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
        body: JSON.stringify(body),
      });

      toast({
        title: "계약이 추가되었습니다.",
        status: "success",
        duration: 1500,
      });
      setAddModalOpen(false);
      setAddForm({
        contractor: "",
        contractor_name: "",
        email: "",
        phone: "",
        partner: "",
        partner_name: "",
        commission: "",
        contract_date: "",
        contract_file: "",
        memo: "",
        test: "FALSE",
        test_period: "",
      });
      fetchRows();
    } else {
      toast({ title: "추가 실패", status: "error", duration: 2000 });
    }
  };

  // 파일 업로드 함수
  const handleFileUpload = async (file) => {
    if (!file) return;
    setUploading(true);
    try {
      const fileExt = file.name.split(".").pop();
      const fileName = `${Date.now()}.${fileExt}`;
      const { data: uploadData, error: uploadError } = await supabase.storage
        .from("contract")
        .upload(fileName, file);
      if (uploadError) throw uploadError;

      // 업로드 후 signedUrl 생성
      const { data: urlData, error: urlError } = await supabase.storage
        .from("contract")
        .createSignedUrl(fileName, 60 * 60 * 24 * 7); // 7일짜리 URL
      if (urlError || !urlData?.signedUrl) throw urlError;

      setAddForm((prev) => ({ ...prev, contract_file: urlData.signedUrl }));
      toast({ title: "파일 업로드 완료", status: "success", duration: 1500 });
    } catch (error) {
      toast({ title: "파일 업로드 실패", status: "error", duration: 2000 });
    } finally {
      setUploading(false);
    }
  };

  // 수정 모달용 파일 업로드 함수
  const handleEditFileUpload = async (file) => {
    if (!file) return;
    setEditUploading(true);
    try {
      const fileExt = file.name.split(".").pop();
      const fileName = `${Date.now()}.${fileExt}`;
      const { error: uploadError } = await supabase.storage
        .from(BUCKET)
        .upload(fileName, file);
      if (uploadError) throw uploadError;
      setEditFields((prev) => ({ ...prev, contract_file: fileName }));
      toast({ title: "파일 업로드 완료", status: "success", duration: 1500 });
    } catch (error) {
      toast({ title: "파일 업로드 실패", status: "error", duration: 2000 });
    } finally {
      setEditUploading(false);
    }
  };

  // 트랙 수수료 수정 저장
  const handleSaveTrackCommission = async () => {
    if (!editTrackCommission.trackId) return;
    setSavingTrackCommission(true);
    try {
      const { error } = await supabase
        .from("album_tracks")
        .update({ commission_rate: editTrackCommission.value })
        .eq("track_id", editTrackCommission.trackId);
      if (error) throw error;
      toast({ title: "수수료 수정 완료", status: "success", duration: 1500 });
      // 목록 새로고침
      const { data, error: fetchError } = await supabase.rpc(
        "fetch_user_album_tracks",
        {
          target_email: infoModal.data.email,
          search_keyword: "",
          page_limit: 1000,
          page_offset: 0,
        }
      );
      if (!fetchError && Array.isArray(data)) {
        const processed = data.map((item) => ({
          id: item.track_code,
          albumId: item.album_id,
          trackCode: item.track_code,
          trackId: item.track_id,
          youtubeId: item.youtube_url
            ? item.youtube_url.match(
                /(?:v=|youtu.be\/|embed\/)([\w-]{11})/
              )?.[1]
            : "",
          youtubeUrl: item.youtube_url,
          trackName: item.track_name,
          albumName: item.album_name,
          albumCover: item.album_cover,
          artist: item.musician_name,
          isrc: item.isrc,
          genre: item.genre || "-",
          mood: Array.isArray(item.mood)
            ? item.mood.join(", ")
            : item.mood || "-",
          mp3: item.mp3,
          wav: item.wav,
          registered_at: item.registered_at,
          published_at: item.published_at,
          commission_rate: item.commission_rate,
        }));
        setOwnedAlbums(processed);
        setOwnedAlbumsTotal(data[0]?.total_count || processed.length);
      }
    } catch (error) {
      toast({ title: "수수료 수정 실패", status: "error", duration: 2000 });
    } finally {
      setSavingTrackCommission(false);
      setEditTrackCommission({ trackId: null, value: "" });
    }
  };

  // 전화번호 포맷팅 함수
  const formatPhoneNumber = (phone) => {
    if (!phone) return "-";
    return phone.startsWith("0") ? phone : `0${phone}`;
  };

  // 숫자 포맷팅 함수
  const formatNumber = (num) => {
    if (!num) return "-";
    return Number(num).toLocaleString();
  };

  // 날짜 포맷팅 함수
  const formatDate = (date) => {
    if (!date) return "-";
    return new Date(date)
      .toLocaleDateString("ko-KR", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .replace(/\. /g, "-")
      .replace(".", "");
  };

  // 계약자 검색 함수
  const handleSearchContractor = async () => {
    if (!addForm.contractor_name) {
      toast({
        title: "계약자명을 입력해주세요",
        status: "warning",
        duration: 2000,
      });
      return;
    }
    setSearchLoading(true);
    try {
      const { data, error } = await supabase
        .from("user")
        .select("*")
        .ilike("name", `%${addForm.contractor_name}%`);

      if (error) throw error;
      setSearchResults(data || []);
      setSearchModalOpen(true);
    } catch (error) {
      toast({
        title: "검색 실패",
        description: error.message,
        status: "error",
        duration: 2000,
      });
    } finally {
      setSearchLoading(false);
    }
  };

  // 검색 결과 선택 처리
  const handleSelectContractor = async (user) => {
    // 계약자 정보 설정
    setAddForm((prev) => ({
      ...prev,
      contractor_name: user.name,
      contractor: user.email,
      email: user.email,
      phone: user.phone_number,
      commission: "10",
      contract_date: new Date().toISOString().split("T")[0],
      test_period: new Date(
        Date.now() + 365 * 24 * 60 * 60 * 1000 - 24 * 60 * 60 * 1000
      )
        .toISOString()
        .split("T")[0],
    }));

    // 파트너 정보가 있는 경우 처리
    if (user.partner) {
      try {
        const { data: partnerData, error } = await supabase
          .from("user")
          .select("name")
          .eq("email", user.partner)
          .single();

        if (!error && partnerData) {
          setAddForm((prev) => ({
            ...prev,
            partner: user.partner,
            partner_name: partnerData.name,
          }));
        }
      } catch (error) {
        console.error("파트너 정보 조회 실패:", error);
      }
    }

    setSearchModalOpen(false);
  };

  const handlePageInput = (e) => {
    const value = e.target.value;
    if (value === "" || /^\d+$/.test(value)) setInputPage(value);
  };

  const handlePageGo = () => {
    const num = parseInt(inputPage, 10);
    if (num >= 1 && num <= Math.max(1, Math.ceil(total / PAGE_SIZE)))
      setPage(num);
    else
      toast({ title: "올바른 페이지 번호를 입력하세요.", status: "warning" });
  };

  return (
    <Box p={6} bg="white">
      <Text fontSize="lg" fontWeight="bold" mb={4}>
        회원 및 계약 정보
      </Text>
      {/* 검색/정렬 UI */}
      <Box
        position="sticky"
        top={0}
        bg="white"
        zIndex={1}
        pb={4}
        borderBottom="1px solid"
        borderColor="gray.200"
      >
        <HStack mb={4} gap={2} align="center">
          <Input
            size="sm"
            width="220px"
            placeholder="계약자명, 이메일, 채널명 검색"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                setPage(1);
                fetchRows(e.target.value);
              }
            }}
          />
          <Select
            size="sm"
            width="140px"
            value={sortBy}
            onChange={(e) => {
              setSortBy(e.target.value);
              setPage(1);
            }}
          >
            <option value="channel_count">등록 채널순</option>
            <option value="created_date">계약일순</option>
          </Select>
          <Select
            size="sm"
            width="100px"
            value={sortOrder}
            onChange={(e) => {
              setSortOrder(e.target.value);
              setPage(1);
            }}
          >
            <option value="desc">내림차순</option>
            <option value="asc">오름차순</option>
          </Select>
          <Button
            size="sm"
            colorScheme="blue"
            onClick={() => {
              setPage(1);
              fetchRows();
            }}
          >
            검색
          </Button>
          <Button
            ml="auto"
            colorScheme="teal"
            size="sm"
            onClick={() => setAddModalOpen(true)}
          >
            계약 추가
          </Button>
        </HStack>
      </Box>
      <Box
        overflowX="auto"
        borderRadius="md"
        borderWidth={1}
        borderColor="gray.200"
        bg="white"
      >
        <Table size="sm" minWidth="1200px" fontSize="xs" tableLayout="fixed">
          <Thead>
            <Tr>
              {COLUMN_MAP.map((col) => (
                <Th
                  key={col.key}
                  bg="gray.100"
                  fontSize="xs"
                  fontWeight="bold"
                  textAlign="center"
                  whiteSpace="nowrap"
                  p={2}
                >
                  {col.label}
                </Th>
              ))}
              <Th
                bg="gray.100"
                fontSize="xs"
                fontWeight="bold"
                textAlign="center"
                p={2}
              >
                정보확인
              </Th>
              <Th
                bg="gray.100"
                fontSize="xs"
                fontWeight="bold"
                textAlign="center"
                p={2}
              >
                삭제
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {loading ? (
              <Tr>
                <Td colSpan={COLUMN_MAP.length + 2} textAlign="center" py={8}>
                  <Spinner size="sm" mr={2} /> 불러오는 중...
                </Td>
              </Tr>
            ) : uniqRows.length === 0 ? (
              <Tr>
                <Td colSpan={COLUMN_MAP.length + 2} textAlign="center" py={8}>
                  데이터가 없습니다.
                </Td>
              </Tr>
            ) : (
              uniqRows.map((row, idx) => (
                <Tr key={row.email + idx}>
                  {COLUMN_MAP.map((col) => (
                    <Td
                      key={col.key}
                      fontSize="xs"
                      textAlign="center"
                      p={2}
                      whiteSpace="nowrap"
                      overflow="hidden"
                      textOverflow="ellipsis"
                      maxW="160px"
                    >
                      {col.key === "represent_channel" ? (
                        getRepresentChannel(row.channels)
                      ) : col.key === "contract_file" ? (
                        row.contract_file ? (
                          <Button
                            size="xs"
                            colorScheme="blue"
                            variant="link"
                            onClick={() =>
                              handleFileDownload(row.contract_file)
                            }
                          >
                            계약서 다운로드
                          </Button>
                        ) : (
                          "-"
                        )
                      ) : col.key === "phone" ? (
                        formatPhoneNumber(row[col.key])
                      ) : col.key === "channel_count" ? (
                        formatNumber(row[col.key])
                      ) : col.key === "contract_date" ? (
                        formatDate(row[col.key])
                      ) : row[col.key] === null ||
                        row[col.key] === undefined ? (
                        "-"
                      ) : (
                        String(row[col.key])
                      )}
                    </Td>
                  ))}
                  <Td textAlign="center" p={2}>
                    <Button
                      size="xs"
                      colorScheme="gray"
                      onClick={() => openInfoModal(row)}
                    >
                      정보확인
                    </Button>
                  </Td>
                  <Td textAlign="center" p={2}>
                    <Button
                      size="xs"
                      colorScheme="red"
                      onClick={() => handleDelete(row)}
                    >
                      삭제
                    </Button>
                  </Td>
                </Tr>
              ))
            )}
          </Tbody>
        </Table>
      </Box>
      <HStack mt={6} justify="center" spacing={2}>
        <Button
          size="xs"
          onClick={() => setPage((p) => Math.max(1, p - 1))}
          disabled={page === 1}
        >
          이전
        </Button>
        <Input
          value={inputPage}
          onChange={handlePageInput}
          onBlur={handlePageGo}
          size="xs"
          width="40px"
          textAlign="center"
          fontSize="xs"
          placeholder="페이지"
        />
        <Button size="xs" onClick={handlePageGo}>
          이동
        </Button>
        <Text fontSize="sm">/ {Math.max(1, Math.ceil(total / PAGE_SIZE))}</Text>
        <Button
          size="xs"
          onClick={() =>
            setPage((p) =>
              Math.min(Math.max(1, Math.ceil(total / PAGE_SIZE)), p + 1)
            )
          }
          disabled={page === Math.max(1, Math.ceil(total / PAGE_SIZE))}
        >
          다음
        </Button>
      </HStack>

      {/* 삭제 확인 다이얼로그 */}
      <AlertDialog
        isOpen={deleteDialog.open}
        leastDestructiveRef={cancelRef}
        onClose={cancelDelete}
      >
        <AlertDialogOverlay />
        <AlertDialogContent>
          <AlertDialogHeader>정말 삭제하시겠습니까?</AlertDialogHeader>
          <AlertDialogBody>
            이 계약 정보를 삭제하면 복구할 수 없습니다.
          </AlertDialogBody>
          <AlertDialogFooter>
            <Button ref={cancelRef} onClick={cancelDelete} size="sm">
              취소
            </Button>
            <Button colorScheme="red" onClick={confirmDelete} ml={3} size="sm">
              삭제
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      {/* 정보확인 모달 */}
      <Modal isOpen={infoModal.open} onClose={closeInfoModal} size="4xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>계약 상세 정보</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {infoModal.data && (
              <Box fontSize="sm">
                {/* 기본 정보 */}
                <Grid templateColumns="repeat(2, 1fr)" gap={4} mb={6}>
                  {COLUMN_MAP.filter(
                    (col) =>
                      !["commission", "contract_file", "memo"].includes(col.key)
                  ).map((col) => (
                    <GridItem key={col.key}>
                      <b>{col.label}:</b>{" "}
                      {col.key === "represent_channel"
                        ? getRepresentChannel(infoModal.data.channels)
                        : col.key === "phone"
                        ? formatPhoneNumber(infoModal.data[col.key])
                        : col.key === "contract_date"
                        ? formatDate(infoModal.data[col.key])
                        : infoModal.data[col.key] === null ||
                          infoModal.data[col.key] === undefined
                        ? "-"
                        : String(infoModal.data[col.key])}
                    </GridItem>
                  ))}
                </Grid>
                {/* 수정 가능 필드 */}
                <Grid templateColumns="repeat(2, 1fr)" gap={4} mb={6}>
                  <GridItem colSpan={2}>
                    <HStack align="center" spacing={6}>
                      <Box>
                        <b>수수료:</b>
                        <ChakraInput
                          size="sm"
                          value={editFields.commission}
                          onChange={(e) =>
                            handleEditFieldChange("commission", e.target.value)
                          }
                          maxW="120px"
                          ml={2}
                        />
                      </Box>
                      <Box>
                        <HStack align="center" spacing={2}>
                          <Box minW="90px">
                            <b>계약서 파일:</b>
                          </Box>
                          <Input
                            type="file"
                            size="sm"
                            maxW="220px"
                            onChange={(e) =>
                              handleEditFileUpload(e.target.files[0])
                            }
                            accept=".pdf,.doc,.docx"
                            isDisabled={editUploading}
                          />
                          {editFields.contract_file && (
                            <Button
                              size="xs"
                              colorScheme="blue"
                              variant="link"
                              onClick={() =>
                                handleFileDownload(editFields.contract_file)
                              }
                              style={{ whiteSpace: "nowrap" }}
                            >
                              계약서 다운로드
                            </Button>
                          )}
                        </HStack>
                      </Box>
                    </HStack>
                  </GridItem>
                  <GridItem colSpan={2}>
                    <b>메모:</b>
                    <Textarea
                      value={editFields.memo}
                      onChange={(e) =>
                        handleEditFieldChange("memo", e.target.value)
                      }
                      maxW="600px"
                      minH="80px"
                      ml={2}
                      size="sm"
                    />
                  </GridItem>
                </Grid>
                {/* 저장 버튼 */}
                <Button
                  colorScheme="blue"
                  onClick={handleSaveEdit}
                  isLoading={saving || editUploading}
                  size="sm"
                  mb={6}
                >
                  저장
                </Button>
                {/* 채널 목록 테이블 + 페이지네이션 */}
                <Box mt={6}>
                  {/* 요약 정보 */}
                  {infoModal.data && (
                    <Box
                      mb={4}
                      width="100%"
                      display="flex"
                      justifyContent="center"
                    >
                      <Box
                        bg="gray.50"
                        borderRadius="xl"
                        px={8}
                        py={4}
                        boxShadow="md"
                        fontWeight="bold"
                        fontSize="lg"
                        textAlign="center"
                        width="fit-content"
                      >
                        {`보유 음반 ${ownedAlbumsTotal || 0}곡   채널 ${
                          Array.isArray(infoModal.data.channels)
                            ? infoModal.data.channels.filter(
                                (ch) => ch.user !== null
                              ).length
                            : 0
                        }개`}
                      </Box>
                    </Box>
                  )}
                  <b>채널 목록</b>
                  <Table size="sm" mt={2} variant="simple" colorScheme="gray">
                    <Thead>
                      <Tr>
                        <Th>채널</Th>
                        <Th>상태</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {Array.isArray(infoModal.data.channels) &&
                      infoModal.data.channels.filter((ch) => ch.user !== null)
                        .length > 0 ? (
                        infoModal.data.channels
                          .filter((ch) => ch.user !== null)
                          .slice(
                            (channelPage - 1) * MODAL_PAGE_SIZE,
                            channelPage * MODAL_PAGE_SIZE
                          )
                          .map((ch, i) => (
                            <Tr key={ch.channel_id || i}>
                              <Td>
                                <HStack align="flex-start">
                                  <Box>
                                    <Text fontWeight="bold">
                                      {ch.channel_title}
                                    </Text>
                                    <Text fontSize="xs" color="gray.500">
                                      {ch.channel_youtube_id}
                                    </Text>
                                  </Box>
                                </HStack>
                              </Td>
                              <Td>{ch.status ?? "-"}</Td>
                            </Tr>
                          ))
                      ) : (
                        <Tr>
                          <Td colSpan={2} textAlign="center">
                            채널 없음
                          </Td>
                        </Tr>
                      )}
                    </Tbody>
                  </Table>
                  {/* 채널 페이지네이션 */}
                  {Array.isArray(infoModal.data.channels) &&
                    infoModal.data.channels.filter((ch) => ch.user !== null)
                      .length > MODAL_PAGE_SIZE && (
                      <HStack mt={2} justify="center" spacing={2}>
                        <IconButton
                          size="xs"
                          aria-label="이전"
                          onClick={() =>
                            setChannelPage((p) => Math.max(1, p - 1))
                          }
                          isDisabled={channelPage === 1}
                          icon={<ChevronLeftIcon />}
                        />
                        <Text fontSize="xs">
                          {channelPage} /{" "}
                          {Math.ceil(
                            infoModal.data.channels.filter(
                              (ch) => ch.user !== null
                            ).length / MODAL_PAGE_SIZE
                          )}
                        </Text>
                        <IconButton
                          size="xs"
                          aria-label="다음"
                          onClick={() =>
                            setChannelPage((p) =>
                              Math.min(
                                Math.ceil(
                                  infoModal.data.channels.filter(
                                    (ch) => ch.user !== null
                                  ).length / MODAL_PAGE_SIZE
                                ),
                                p + 1
                              )
                            )
                          }
                          isDisabled={
                            channelPage ===
                            Math.ceil(
                              infoModal.data.channels.filter(
                                (ch) => ch.user !== null
                              ).length / MODAL_PAGE_SIZE
                            )
                          }
                          icon={<ChevronRightIcon />}
                        />
                      </HStack>
                    )}
                </Box>
                {/* 소유 음반 목록 테이블 + 페이지네이션 */}
                <Box mt={6}>
                  <b>소유 음반 목록</b>
                  <Table size="sm" mt={2} variant="simple" colorScheme="teal">
                    <Thead>
                      <Tr bg="gray.50">
                        <Th>음반</Th>
                        <Th>ISRC</Th>
                        <Th>등록일</Th>
                        <Th>수수료</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {Array.isArray(ownedAlbums) && ownedAlbums.length > 0 ? (
                        ownedAlbums
                          .slice(
                            (albumPage - 1) * MODAL_PAGE_SIZE,
                            albumPage * MODAL_PAGE_SIZE
                          )
                          .map((own, i) => (
                            <Tr key={own.id || i} _hover={{ bg: "gray.50" }}>
                              <Td>
                                <HStack align="flex-start">
                                  <Image
                                    src={
                                      own.albumCover ||
                                      "/images/default-album.png"
                                    }
                                    alt={own.albumName}
                                    boxSize="40px"
                                    borderRadius="md"
                                  />
                                  <Box>
                                    <Text fontWeight="bold">
                                      {own.trackName || "-"}
                                    </Text>
                                    <Text fontSize="xs" color="gray.500">
                                      {own.artist || "-"}
                                    </Text>
                                  </Box>
                                </HStack>
                              </Td>
                              <Td>{own.isrc || "-"}</Td>
                              <Td>
                                {own.registered_at
                                  ? formatDate(own.registered_at)
                                  : "-"}
                              </Td>
                              <Td>
                                {editTrackCommission.trackId === own.trackId ? (
                                  <HStack>
                                    <ChakraInput
                                      size="xs"
                                      value={editTrackCommission.value}
                                      onChange={(e) =>
                                        setEditTrackCommission((prev) => ({
                                          ...prev,
                                          value: e.target.value,
                                        }))
                                      }
                                      maxW="100px"
                                    />
                                    <IconButton
                                      size="xs"
                                      colorScheme="blue"
                                      icon={<CheckIcon />}
                                      onClick={handleSaveTrackCommission}
                                      isLoading={savingTrackCommission}
                                    />
                                    <IconButton
                                      size="xs"
                                      colorScheme="gray"
                                      icon={<CloseIcon />}
                                      onClick={() =>
                                        setEditTrackCommission({
                                          trackId: null,
                                          value: "",
                                        })
                                      }
                                    />
                                  </HStack>
                                ) : (
                                  <HStack>
                                    <Text>{own.commission_rate || "-"}</Text>
                                    <IconButton
                                      size="xs"
                                      colorScheme="blue"
                                      icon={<EditIcon />}
                                      onClick={() =>
                                        setEditTrackCommission({
                                          trackId: own.trackId,
                                          value: own.commission_rate || "",
                                        })
                                      }
                                    />
                                  </HStack>
                                )}
                              </Td>
                            </Tr>
                          ))
                      ) : (
                        <Tr>
                          <Td colSpan={4} textAlign="center">
                            소유 음반 없음
                          </Td>
                        </Tr>
                      )}
                    </Tbody>
                  </Table>
                  {/* 음반 페이지네이션 */}
                  {Array.isArray(ownedAlbums) &&
                    ownedAlbums.length > MODAL_PAGE_SIZE && (
                      <HStack mt={2} justify="center" spacing={2}>
                        <IconButton
                          size="xs"
                          aria-label="이전"
                          onClick={() =>
                            setAlbumPage((p) => Math.max(1, p - 1))
                          }
                          isDisabled={albumPage === 1}
                          icon={<ChevronLeftIcon />}
                        />
                        <Text fontSize="xs">
                          {albumPage} /{" "}
                          {Math.ceil(ownedAlbums.length / MODAL_PAGE_SIZE)}
                        </Text>
                        <IconButton
                          size="xs"
                          aria-label="다음"
                          onClick={() =>
                            setAlbumPage((p) =>
                              Math.min(
                                Math.ceil(ownedAlbums.length / MODAL_PAGE_SIZE),
                                p + 1
                              )
                            )
                          }
                          isDisabled={
                            albumPage ===
                            Math.ceil(ownedAlbums.length / MODAL_PAGE_SIZE)
                          }
                          icon={<ChevronRightIcon />}
                        />
                      </HStack>
                    )}
                </Box>
              </Box>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
      {/* 계약 추가 모달 */}
      <Modal
        isOpen={addModalOpen}
        onClose={() => setAddModalOpen(false)}
        size="xl"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>계약 추가</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Grid templateColumns="repeat(2, 1fr)" gap={4}>
              <GridItem colSpan={2}>
                <FormControl isRequired>
                  <FormLabel>계약자명</FormLabel>
                  <HStack>
                    <ChakraInput
                      size="sm"
                      value={addForm.contractor_name}
                      onChange={(e) =>
                        handleAddChange("contractor_name", e.target.value)
                      }
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          handleSearchContractor();
                        }
                      }}
                    />
                    <Button
                      size="sm"
                      colorScheme="blue"
                      onClick={handleSearchContractor}
                      isLoading={searchLoading}
                    >
                      찾기
                    </Button>
                  </HStack>
                </FormControl>
              </GridItem>
              <GridItem colSpan={2}>
                <FormControl isRequired>
                  <FormLabel>계약자(이메일)</FormLabel>
                  <ChakraInput
                    size="sm"
                    value={addForm.contractor}
                    onChange={(e) =>
                      handleAddChange("contractor", e.target.value)
                    }
                  />
                </FormControl>
              </GridItem>
              <FormControl>
                <FormLabel>이메일</FormLabel>
                <ChakraInput
                  size="sm"
                  value={addForm.email}
                  onChange={(e) => handleAddChange("email", e.target.value)}
                />
              </FormControl>
              <FormControl>
                <FormLabel>전화번호</FormLabel>
                <ChakraInput
                  size="sm"
                  value={addForm.phone}
                  onChange={(e) => handleAddChange("phone", e.target.value)}
                />
              </FormControl>
              <FormControl>
                <FormLabel>파트너(이메일)</FormLabel>
                <ChakraInput
                  size="sm"
                  value={addForm.partner}
                  onChange={(e) => handleAddChange("partner", e.target.value)}
                />
              </FormControl>
              <FormControl>
                <FormLabel>파트너명</FormLabel>
                <ChakraInput
                  size="sm"
                  value={addForm.partner_name}
                  onChange={(e) =>
                    handleAddChange("partner_name", e.target.value)
                  }
                />
              </FormControl>
              <FormControl>
                <FormLabel>수수료</FormLabel>
                <ChakraInput
                  size="sm"
                  value={addForm.commission}
                  onChange={(e) =>
                    handleAddChange("commission", e.target.value)
                  }
                />
              </FormControl>
              <FormControl>
                <FormLabel>계약일</FormLabel>
                <ChakraInput
                  size="sm"
                  type="date"
                  value={addForm.contract_date}
                  onChange={(e) =>
                    handleAddChange("contract_date", e.target.value)
                  }
                />
              </FormControl>
              <GridItem colSpan={2}>
                <FormControl>
                  <FormLabel>계약서 파일</FormLabel>
                  <HStack>
                    <Input
                      type="file"
                      size="sm"
                      onChange={(e) => handleFileUpload(e.target.files[0])}
                      accept=".pdf,.doc,.docx"
                      isDisabled={uploading}
                    />
                    {addForm.contract_file && (
                      <Text fontSize="sm" color="green.500">
                        {addForm.contract_file}
                      </Text>
                    )}
                  </HStack>
                </FormControl>
              </GridItem>
              <GridItem colSpan={2}>
                <FormControl>
                  <FormLabel>테스트 여부</FormLabel>
                  <Select
                    size="sm"
                    value={addForm.test}
                    onChange={(e) => handleAddChange("test", e.target.value)}
                  >
                    <option value="TRUE">TRUE</option>
                    <option value="FALSE">FALSE</option>
                  </Select>
                </FormControl>
              </GridItem>
              <GridItem colSpan={2}>
                <FormControl>
                  <FormLabel>계약 종료일(기존 테스트 기간)</FormLabel>
                  <ChakraInput
                    size="sm"
                    type="date"
                    value={addForm.test_period}
                    onChange={(e) =>
                      handleAddChange("test_period", e.target.value)
                    }
                  />
                </FormControl>
              </GridItem>
              <GridItem colSpan={2}>
                <FormControl>
                  <FormLabel>메모</FormLabel>
                  <Textarea
                    value={addForm.memo}
                    onChange={(e) => handleAddChange("memo", e.target.value)}
                    minH="80px"
                  />
                </FormControl>
              </GridItem>
            </Grid>
          </ModalBody>
          <ModalFooter>
            <Button onClick={() => setAddModalOpen(false)} mr={3} size="sm">
              취소
            </Button>
            <Button
              colorScheme="teal"
              onClick={handleAddSave}
              isLoading={adding || uploading}
              size="sm"
            >
              저장
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      {/* 계약자 검색 결과 모달 */}
      <Modal
        isOpen={searchModalOpen}
        onClose={() => setSearchModalOpen(false)}
        size="md"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>계약자 검색 결과</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {searchResults.length === 0 ? (
              <Text textAlign="center" py={4}>
                검색 결과가 없습니다.
              </Text>
            ) : (
              <VStack spacing={2} align="stretch">
                {searchResults.map((user) => (
                  <Button
                    key={user.email}
                    variant="outline"
                    onClick={() => handleSelectContractor(user)}
                    justifyContent="flex-start"
                    textAlign="left"
                    height="auto"
                    py={2}
                  >
                    <VStack align="start" spacing={1}>
                      <Text fontWeight="bold">{user.name}</Text>
                      <Text fontSize="sm" color="gray.600">
                        {user.email}
                      </Text>
                    </VStack>
                  </Button>
                ))}
              </VStack>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default Contracts;
